import $axios from "../../api";

const PREFIX = "website/promotion";

const state = () => ({
  isLoading: false,
  loadingDownload: false,
  isErrors: null,
  isSuccess: false,
  showhide: null,
  page: 1,
  list: null,
  detail: null,

  voucherData: null,
  shippingData: null,
  pwpData: null,
  additionalData: null,
});

const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  SET_LOADING_DOWNLOAD(state, payload) {
    state.loadingDownload = payload;
  },
  ASSIGN_ERRORS(state, payload) {
    state.isErrors = payload;
  },
  SET_IS_SUCCESS(state, payload) {
    state.isSuccess = payload;
  },
  SET_PAGE(state, payload) {
    state.page = payload;
  },
  SET_LIST(state, payload) {
    state.list = payload;
  },
  SET_DETAIL(state, payload) {
    state.detail = payload;
  },
  ASSIGN_VOUCHER_DATA(state, payload) {
    state.voucherData = payload
  },
  ASSIGN_SHIPPING_DATA(state, payload) {
    state.shippingData = payload
  },
  ASSIGN_PWP_DATA(state, payload) {
    state.pwpData = payload
  },
  ASSIGN_ADDITIONAL_DATA(state, payload) {
    state.additionalData = payload
  },
  ASSIGN_SHOWHIDE(state, payload) {
    state.showhide = payload;
  }
};

const actions = {
  getList({ commit, state, rootState, dispatch }, query = "") {
    commit("SET_LOADING", true);
    commit("ASSIGN_ERRORS", null);
    commit("SET_IS_SUCCESS", false);

    const page = state.page;
    const view = rootState.Main.view;

    return $axios
      .get(`${PREFIX}/list?page=${page}&view=${view}${query}`)
      .then((res) => {
        commit("SET_LIST", res.data.data);
        commit("SET_LOADING", false);
        commit("SET_IS_SUCCESS", true);
      })
      .catch((error) => {
        commit("SET_LOADING", false);
        commit("ASSIGN_ERRORS", error.response);
        commit("SET_IS_SUCCESS", false);
        dispatch("Main/globalSweetAlert", error.response, { root: true });
        throw error;
      });
  },
  getView({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);

    return $axios
      .get(`${PREFIX}/view?id=${payload}`)
      .then((res) => {
        commit("SET_DETAIL", res.data.data);
        commit("SET_LOADING", false);
      })
      .catch((error) => {
        commit("SET_LOADING", false);
        dispatch("Main/globalSweetAlert", error.response, { root: true });
        throw error;
      });
  },
  showHidePromotion({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("SET_IS_SUCCESS", false);
    return new Promise((resolve, reject) => {
      $axios
        .post(`${PREFIX}/showhide`, payload)
        .then((res) => {
          commit("SET_IS_SUCCESS", true);
          commit("ASSIGN_SHOWHIDE", res.data.message);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  async createRegularPromo({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("ASSIGN_ERRORS", null);
    commit("SET_IS_SUCCESS", false);

    try {
      const response = await $axios.post(`${PREFIX}/regular/create`, payload);

      commit("SET_LOADING", false);
      commit("SET_IS_SUCCESS", true);
      commit("ASSIGN_ERRORS", null);

      return response.data;

    } catch (error) {
      commit("SET_LOADING", false);
      commit("SET_IS_SUCCESS", false);
      commit("ASSIGN_ERRORS", error.response.data.errors || error.response.data.message);
      dispatch("Main/globalSweetAlert", error.response, { root: true });
      throw error;
    }
  },

  async getPromoById({ commit, dispatch }, id) {
    commit("SET_LOADING", true);
    commit("ASSIGN_ERRORS", null);
    try {
      const response = await $axios.get(`${PREFIX}/regular/view?id=${id}`);
      commit("SET_LOADING", false);
      return response.data.data;
    } catch (error) {
      commit("SET_LOADING", false);
      commit("ASSIGN_ERRORS", error.response);
      dispatch("Main/globalSweetAlert", error.response, { root: true });
      throw error;
    }
  },

  async createBuyGetPromo({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("ASSIGN_ERRORS", null);
    commit("SET_IS_SUCCESS", false);

    try {
      const response = await $axios.post(`${PREFIX}/buyget/create`, payload);
      commit("SET_LOADING", false);
      commit("SET_IS_SUCCESS", true);
      commit("ASSIGN_ERRORS", null);
      return response.data;
    } catch (error) {
      commit("SET_LOADING", false);
      commit("SET_IS_SUCCESS", false);
      commit("ASSIGN_ERRORS", error.response.data.errors || error.response.data.message);
      dispatch("Main/globalSweetAlert", error.response, { root: true });
      throw error;
    }
  },

  async getBuyGetPromoById({ commit, dispatch }, id) {
    commit("SET_LOADING", true);
    commit("ASSIGN_ERRORS", null);
    try {
      // Menggunakan query parameter ?id= sesuai dengan backend Anda
      const response = await $axios.get(`${PREFIX}/buyget/view?id=${id}`);
      commit("SET_LOADING", false);
      return response.data.data;
    } catch (error) {
      commit("SET_LOADING", false);
      commit("ASSIGN_ERRORS", error.response);
      dispatch("Main/globalSweetAlert", error.response, { root: true });
      throw error;
    }
  },

  async createMinQtyPromo({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("ASSIGN_ERRORS", null);
    commit("SET_IS_SUCCESS", false);

    try {
      const response = await $axios.post(`${PREFIX}/minqty/create`, payload);
      commit("SET_LOADING", false);
      commit("SET_IS_SUCCESS", true);
      commit("ASSIGN_ERRORS", null);
      return response.data;
    } catch (error) {
      commit("SET_LOADING", false);
      commit("SET_IS_SUCCESS", false);
      commit("ASSIGN_ERRORS", error.response.data.errors || error.response.data.message);
      dispatch("Main/globalSweetAlert", error.response, { root: true });
      throw error;
    }
  },

  async getMinQtyPromoById({ commit, dispatch }, id) {
    commit("SET_LOADING", true);
    commit("ASSIGN_ERRORS", null);
    try {
      const response = await $axios.get(`${PREFIX}/minqty/view?id=${id}`);
      commit("SET_LOADING", false);
      return response.data.data;
    } catch (error) {
      commit("SET_LOADING", false);
      commit("ASSIGN_ERRORS", error.response);
      dispatch("Main/globalSweetAlert", error.response, { root: true });
      throw error;
    }
  },

  async updateMinQtyPromo({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("ASSIGN_ERRORS", null);
    commit("SET_IS_SUCCESS", false);

    try {
      const response = await $axios.post(`${PREFIX}/minqty/update`, payload);
      commit("SET_LOADING", false);
      commit("SET_IS_SUCCESS", true);
      commit("ASSIGN_ERRORS", null);
      return response.data;
    } catch (error) {
      commit("SET_LOADING", false);
      commit("SET_IS_SUCCESS", false);
      commit("ASSIGN_ERRORS", error.response.data.errors || error.response.data.message);
      dispatch("Main/globalSweetAlert", error.response, { root: true });
      throw error;
    }
  },

  async createVoucherPromo({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("ASSIGN_ERRORS", null);
    commit("SET_IS_SUCCESS", false);

    try {
      await $axios.post(`${PREFIX}/voucher/create`, payload)
      commit("SET_IS_SUCCESS", true);
    } catch (error) {
      commit("ASSIGN_ERRORS", error.response);
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit("SET_LOADING", false);
    }

    return
  },

  async getVoucherPromo({ commit, dispatch }, id) {
    commit("SET_LOADING", true);
    commit("ASSIGN_ERRORS", null);
    try {
      // Menggunakan query parameter ?id= sesuai dengan backend Anda
      const response = await $axios.get(`${PREFIX}/voucher/view/${id}`);
      commit("ASSIGN_VOUCHER_DATA", response.data.data)
    } catch (error) {
      commit("ASSIGN_ERRORS", error.response);
      dispatch("Main/globalSweetAlert", error.response, { root: true });

    } finally {
      commit("SET_LOADING", false);
    }

    return
  },

  async createFreeShipping({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("ASSIGN_ERRORS", null);
    commit("SET_IS_SUCCESS", false);

    try {
      await $axios.post(`${PREFIX}/shipping/create`, payload)
      commit("SET_IS_SUCCESS", true);
    } catch (error) {
      commit("ASSIGN_ERRORS", error.response);
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit("SET_LOADING", false);
    }

    return
  },

  async getFreeShippingPromo({ commit, dispatch }, id) {
    commit("SET_LOADING", true);
    commit("ASSIGN_ERRORS", null);
    try {
      // Menggunakan query parameter ?id= sesuai dengan backend Anda
      const response = await $axios.get(`${PREFIX}/shipping/view/${id}`);
      commit("ASSIGN_SHIPPING_DATA", response.data.data)
    } catch (error) {
      commit("ASSIGN_ERRORS", error.response);
      dispatch("Main/globalSweetAlert", error.response, { root: true });

    } finally {
      commit("SET_LOADING", false);
    }

    return
  },

  async createAddtionalPromo({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("ASSIGN_ERRORS", null);
    commit("SET_IS_SUCCESS", false);

    try {
      const response = await $axios.post(`${PREFIX}/additional/create`, payload);
      commit("SET_LOADING", false);
      commit("SET_IS_SUCCESS", true);
      commit("ASSIGN_ERRORS", null);
      return response.data;
    } catch (error) {
      commit("SET_LOADING", false);
      commit("SET_IS_SUCCESS", false);
      commit("ASSIGN_ERRORS", error.response.data.errors || error.response.data.message);
      dispatch("Main/globalSweetAlert", error.response, { root: true });
      throw error;
    }
  },

  async getAdditionalPromo({ commit, dispatch }, id) {
    commit("SET_LOADING", true);
    commit("ASSIGN_ERRORS", null);
    try {
      // Menggunakan query parameter ?id= sesuai dengan backend Anda
      const response = await $axios.get(`${PREFIX}/additional/view/${id}`);
      commit("ASSIGN_ADDITIONAL_DATA", response.data.data)
    } catch (error) {
      commit("ASSIGN_ERRORS", error.response);
      dispatch("Main/globalSweetAlert", error.response, { root: true });

    } finally {
      commit("SET_LOADING", false);
    }

    return
  },

  async createPwp({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("ASSIGN_ERRORS", null);
    commit("SET_IS_SUCCESS", false);
    try {
      await $axios.post(`${PREFIX}/pwp/create`, payload)
      commit("SET_IS_SUCCESS", true);
    } catch (error) {
      commit("ASSIGN_ERRORS", error.response);
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit("SET_LOADING", false);
    }
    return
  },

  async getPwpPromo({ commit, dispatch }, id) {
    commit("SET_LOADING", true);
    commit("ASSIGN_ERRORS", null);
    try {
      // Menggunakan query parameter ?id= sesuai dengan backend Anda
      const response = await $axios.get(`${PREFIX}/pwp/view/${id}`);
      commit("ASSIGN_PWP_DATA", response.data.data)
    } catch (error) {
      commit("ASSIGN_ERRORS", error.response);
      dispatch("Main/globalSweetAlert", error.response, { root: true });

    } finally {
      commit("SET_LOADING", false);
    }

    return
  },

  async downloadVoucher({ commit, dispatch }, id) {
    commit("SET_LOADING_DOWNLOAD", true);
    commit("ASSIGN_ERRORS", null);
    try {
      const response = await $axios.get(`${PREFIX}/download-voucher/${id}`, {
        responseType: 'blob'
      })

      let fileName = null
      const contentDisposition = response.headers['content-disposition']
      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (fileNameMatch && fileNameMatch[1]) {
          fileName = fileNameMatch[1].replace(/['"]/g, '');
        }
      }

      const url = window.URL.createObjectURL(new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }));

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      commit("ASSIGN_ERRORS", error.response);
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit("SET_LOADING_DOWNLOAD", false);
    }
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
